import {
	AddPrivacySolution,
	BlockColdSolution,
	BlockHeatSolution,
	BlockLightSolution,
	BlockNoiseSolution,
	BlockPollutantsSolution,
	BlockUVSolution,
	PreventCondensationSolution,
	SaveMoneySolution,
} from '../solutions/solutions-data';

import product_diagram from './images/Product-Standard_Grade-crosscut-diagram.png';
import product_bathroom from './images/product_bathroom.jpg';
import product_bathroom_thumbnail from './images/product_bathroom.jpg?w=160';
import product_blackoutdark from './images/product_blackout-dark.jpg';
import product_blackoutinstall from './images/product_blackout-install.jpg';
import product_blackoutinstall_thumbnail from './images/product_blackout-install.jpg?w=160';
import product_blackoutlight from './images/product_blackout-light.jpg';
import product_comercial1 from './images/product_comercial-1.jpg';
import product_comercial3 from './images/product_comercial-3.jpg';
import product_comercial3_thumbnail from './images/product_comercial-3.jpg?w=160';
import product_corner1 from './images/product_corner-1.jpg';
import product_corner1_thumbnail from './images/product_corner-1.jpg?w=160';
import product_corner2 from './images/product_corner-2.jpg';
import product_corner2_thumbnail from './images/product_corner-2.jpg?w=160';
import product_kitcheninstall50 from './images/product_kitchen-install-50-percent.jpg';
import product_kitcheninstall70 from './images/product_kitchen-install-70-percent.jpg';
import product_livingroominstall from './images/product_livingroom-install.jpg';
import product_livingroominstall_thumbnail from './images/product_livingroom-install.jpg?w=160';

import acousticTechDiagramImage from './images/Product-Acoustic_Grade-noise-Technical_diagram.svg';
import museumTechDiagramImage from './images/Product-Museum_Grade-UV_light-Technical_diagram.svg';
import draftsTechDiagramImage from './images/Product-Standard_Grade-Drafts-Technical_diagram.svg';
import tempertureTechDiagramImage from './images/Product-Standard_Grade-temperature-Technical_diagram.svg';

import stickerEnergySavingsImage from './images/sticker-energy-savings.svg';
import stickerNoiseReductionImage from './images/sticker-noise-reduction.svg';

const ThermalProduct = {
	title: 'Thermal Inserts',
	grade: 'Standard Grade Acrylic',
	price: 28,
	price_individual: 31,
	href: '/products/thermal-window-inserts',
	thumbnail: product_corner1_thumbnail,
	images: [
		product_corner1,
		product_kitcheninstall50,
		product_diagram,
		tempertureTechDiagramImage,
		draftsTechDiagramImage,
	],
	sticker: stickerEnergySavingsImage,
	related: [], // see below
	solutions: [
		BlockNoiseSolution,
		BlockColdSolution,
		BlockHeatSolution,
		SaveMoneySolution,
		BlockPollutantsSolution,
		PreventCondensationSolution,
	],
	body: 'Block cold drafts in the winter, keep the cool air inside during the summer, and save an average of 20% on your heating & cooling bills. These climate control window inserts also reduce noise up to 50%, while preventing condensation and keeping pollen & pollutants outdoors.',
	summary:
		'Block cold drafts in the winter, keep the cool air inside during the summer, and save an average of 20% on your heating & cooling bills. These climate control inserts also reduce noise up to 50% and prevent condensation.',
	noise: 50,
};

const AcousticProduct = {
	title: 'Acoustic Inserts',
	grade: 'Acoustic Grade Acrylic',
	price: 36,
	price_individual: 40,
	href: '/products/acoustic-window-inserts',
	thumbnail: product_corner2_thumbnail,
	images: [
		product_corner2,
		product_kitcheninstall70,
		product_diagram,
		acousticTechDiagramImage,
	],
	sticker: stickerNoiseReductionImage,
	related: [], // see below
	solutions: [
		BlockNoiseSolution,
		BlockColdSolution,
		BlockHeatSolution,
		SaveMoneySolution,
		BlockPollutantsSolution,
		PreventCondensationSolution,
	],
	body: 'Acoustic grade window inserts reduce noise up to 70% - making your home nearly soundproof. They also reduce temperature transfer, and save an average of 20% on your heating & cooling bills, while preventing condensation and keeping pollen & pollutants outdoors.',
	summary:
		'Acoustic grade inserts reduce noise up to 70% - making your home nearly soundproof, while saving an average of 20% on your heating & cooling bills, preventing condensation, and keeping pollen & pollutants outdoors.',
	noise: 70,
};

const UvProduct = {
	title: 'UV Blocking Inserts',
	grade: 'Museum Grade Acrylic',
	price: 36,
	price_individual: 40,
	href: '/products/uv-blocking-window-inserts',
	thumbnail: product_livingroominstall_thumbnail,
	images: [
		product_livingroominstall,
		product_kitcheninstall50,
		product_diagram,
		museumTechDiagramImage,
	],
	sticker: stickerEnergySavingsImage,
	related: [], // see below
	solutions: [
		BlockUVSolution,
		BlockNoiseSolution,
		BlockColdSolution,
		BlockHeatSolution,
		SaveMoneySolution,
		PreventCondensationSolution,
	],
	body: 'UV Blocking window inserts block up to 98% of harmful UV rays, protecting your valuables from sun damage. They also reduce noise up to 50% and save an average of 20% on your heating & cooling bills, while preventing condensation and keeping pollen & pollutants outdoors.',
	summary:
		'Block 98% of harmful UV rays to protect your valuables from sun damage, while saving an average of 20% on your heating & cooling bills, reducing noise up to 50%, and keeping out condensation, pollen, and other pollutants.',
	noise: 50,
};

const SleepProduct = {
	title: 'Sleep Panels',
	grade: 'Sleep Grade',
	price: 27,
	price_individual: 28,
	href: '/products/sleep-panels',
	thumbnail: product_blackoutinstall_thumbnail,
	images: [
		product_blackoutinstall,
		product_blackoutlight,
		product_blackoutdark,
		acousticTechDiagramImage,
	],
	sticker: stickerEnergySavingsImage,
	related: [], // see below
	solutions: [
		BlockLightSolution,
		BlockNoiseSolution,
		BlockColdSolution,
		BlockHeatSolution,
		SaveMoneySolution,
		PreventCondensationSolution,
	],
	body: 'Sleep panels block 100% of light, creating complete darkness in your space. They also help reduce noise and save energy wasted on heating & cooling, while preventing condensation and keeping pollen & pollutants outdoors.',
	summary:
		'Block 100% of light to achieve complete darkness at all hours of the day, while saving an energy on your heating & cooling bills, reducing noise, and keeping out condensation, pollen, and other pollutants.',
	noise: 50,
};

const PrivacyProduct = {
	title: 'Privacy Inserts',
	grade: 'Privacy Grade Acrylic',
	price: 36,
	price_individual: 40,
	href: '/products/privacy-inserts',
	thumbnail: product_bathroom_thumbnail,
	images: [product_bathroom, product_kitcheninstall50, product_diagram],
	sticker: stickerEnergySavingsImage,
	related: [], // see below
	solutions: [
		AddPrivacySolution,
		BlockNoiseSolution,
		BlockColdSolution,
		BlockHeatSolution,
		SaveMoneySolution,
		PreventCondensationSolution,
	],
	body: 'Privacy inserts obscure visibility in sensitive areas of your home without blocking light. They also reduce noise up to 50% and save an average of 20% on your heating & cooling bills, while preventing condensation and keeping pollen & pollutants outdoors.',
	summary:
		'Keep prying eyes away with privacy inserts that obscure visibility without blocking light, while saving an average of 20% on your heating & cooling bills, reducing noise up to 50%, and keeping out condensation, pollen, and other pollutants.',
	noise: 50,
};

const CommercialProduct = {
	title: 'Commercial Inserts',
	grade: 'Commercial Grade Acrylic',
	price: 40,
	price_individual: 44,
	href: '/products/commercial-window-inserts',
	thumbnail: product_comercial3_thumbnail,
	images: [
		product_comercial3,
		product_comercial1,
		product_kitcheninstall70,
		product_diagram,
	],
	sticker: stickerNoiseReductionImage,
	related: [], // see below
	solutions: [
		BlockNoiseSolution,
		BlockColdSolution,
		BlockHeatSolution,
		SaveMoneySolution,
		PreventCondensationSolution,
		BlockPollutantsSolution,
	],
	body: 'Our Thermal Inserts and Acoustic Inserts are available in scratch-resistant, easy to clean Commercial Acrylic ideal for high-traffic areas. Commercial grade inserts require no special cleaning solutions and can withstand daily wear and tear while delivering all the same performance of ou standard window inserts. ',
	summary: 'n/a',
	noise: 70,
};

/*
 * Assign Related Products - After they are all created.
 */
ThermalProduct.related = [AcousticProduct, UvProduct, CommercialProduct];
AcousticProduct.related = [ThermalProduct, UvProduct, CommercialProduct];
UvProduct.related = [AcousticProduct, SleepProduct, ThermalProduct];
SleepProduct.related = [AcousticProduct, PrivacyProduct, UvProduct];
PrivacyProduct.related = [AcousticProduct, ThermalProduct, UvProduct];
CommercialProduct.related = [AcousticProduct, ThermalProduct, UvProduct];

export {
	AcousticProduct,
	CommercialProduct,
	PrivacyProduct,
	SleepProduct,
	ThermalProduct,
	UvProduct,
};
